<template lang="pug">
  div
    el-row
      component(:is="changeComponent", ref="wapClients")
</template>
<script>

import WapClientsPa from '@/screens/manutencao/pa/WapClientsPa'
import WapClientsMa from '@/screens/manutencao/ma/WapClientsMa'
import WapClientsAp from '@/screens/manutencao/ap/WapClientsAp'

export default {

  components: {
    WapClientsPa,
    WapClientsMa,
    WapClientsAp
  },

  computed: {
    changeComponent () {
      switch (process.env.ESTADO) {
        case 'ma':
          return 'WapClientsMa'
        case 'ap':
          return 'WapClientsAp'
        default:
          return 'WapClientsPa'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/manutencao/WapClients.vue